import { AmbassadorDetail } from '@omniafishing/core';
import { Button } from 'antd';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useUserAmbassadors } from '../../../../hooks/use_user_ambassadors';
import { OmniaUrls } from '../../../../lib/urls';
import { NAME_FALLBACK, roleAsText } from '../../../../lib/user';
import { AmbassadorColorDot } from '../../../ambassador_color_dot/ambassador_color_dot';
import { UserProfileImg } from '../../../user_profile_img/user_profile_img';
import { UserProfileNotificationsModal } from '../../../user_profile_notifications_modal/user_profile_notifications_modal';
import styles from './waterbody_detail_user_profile_card.less';

interface WaterbodyDetailUserProfileCardProps {
  profile: AmbassadorDetail;
  onClick?: () => void;
}

export const WaterbodyDetailUserProfileCard = (props: WaterbodyDetailUserProfileCardProps) => {
  const { profile, onClick } = props;
  const { image, slug, full_name, role } = profile;
  const { userAmbassadors, unfollowAmbassador } = useUserAmbassadors();
  const [notificationModalVisible, setNotificationModalVisible] = useState(false);

  const isUserFollowingAmbassador = !!userAmbassadors.find((a) => a.slug === slug);

  const closeNotificationModal = () => {
    setNotificationModalVisible(false);
  };

  return (
    <>
      <Link
        target={'_blank'}
        to={OmniaUrls.user(profile)}
        className={styles.link}
        onClick={() => {
          onClick?.();
        }}
      >
        <div className={styles.img}>
          <UserProfileImg image={image} size={null} imageSize={200} />
        </div>
        <span className={styles.name}>{full_name || NAME_FALLBACK}</span>
        <p className={styles.role}>
          <AmbassadorColorDot user={profile} />
          {roleAsText(role)} Ambassador
        </p>
      </Link>

      {/* TODO MAKE THIS BUTTON A COMPONENT THAT'S ALSO USED
      ON USER PROFILE PAGE */}
      {isUserFollowingAmbassador ? (
        <div className={styles.followBtn}>
          <Button
            onClick={() => {
              unfollowAmbassador.mutate({
                ambassador: profile,
              });
            }}
            size="large"
            type="primary"
          >
            Unfollow
          </Button>
        </div>
      ) : (
        <div className={styles.followBtn}>
          <Button
            className={styles.notificationsButton}
            onClick={() => {
              setNotificationModalVisible(true);
            }}
            type="primary"
            size="large"
          >
            Follow
          </Button>
        </div>
      )}
      <UserProfileNotificationsModal
        userProfile={profile}
        open={notificationModalVisible}
        favorite={isUserFollowingAmbassador}
        event_notifications={profile.user_event_notifications}
        onClose={closeNotificationModal}
      />
    </>
  );
};
